import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  clearSchools: null,

  getSchoolsFailure: null,
  getSchoolsRequest: ["params", "resolve", "reject"],
  getSchoolsSuccess: ["schoolsData", "params"],

  getSchoolFailure: null,
  getSchoolRequest: ["params"],
  getSchoolSuccess: ["partner"],

  getAvailabilitiesFailure: null,
  getAvailabilitiesRequest: ["params"],
  getAvailabilitiesSuccess: ["availabilities"],

  setSlotStateFailure: null,
  setSlotStateRequest: ["params"],
  setSlotStateSuccess: null,

  getPendingFeedbacksFailure: null,
  getPendingFeedbacksRequest: null,
  getPendingFeedbacksSuccess: ["pendingFeedbacks"],

  addFeedbackFailure: null,
  addFeedbackRequest: ["data", "eventId"],
  addFeedbackSuccess: null,

  // Paged list of received reviews plus the category averages, used by the
  // BridgeU reviews modal.
  getFeedbacksFailure: null,
  getFeedbacksRequest: ["schoolId", "page"],
  getFeedbacksSuccess: ["feedbacksData", "page"],

  skipFeedbackFailure: null,
  skipFeedbackRequest: ["eventId"],
  skipFeedbackSuccess: null,
});

export const SchoolsTypes = Types;
export const SchoolsCreators = Creators;
